import { Component, Inject, Input, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { TruckOwnerService } from "../truck-owner.service";

@Component({
  selector: "app-trucks-view",
  templateUrl: "./trucks-view.component.html",
  styleUrls: ["./trucks-view.component.css"],
})
export class TrucksViewComponent implements OnInit {
  uploadVehicle: boolean = true;
  uploadPermit: boolean = true;
  uploadFitness: boolean = true;
  uploadPollution: boolean = true;
  uploadInsurance: boolean = true;
  file: any = "";
  editTruckProfile: boolean = false;
  truckProfile: boolean = true;
  date = new FormControl(new Date());
  serializedDate = new FormControl(new Date().toISOString());
  today: any;
  truckImage: any;
  @Input() min: any;
  minDate = new Date();
  @Input() max: any;
  maxDate = new Date();
  updateRC: boolean = true;
  updatePermit: boolean = true;
  updateFitness: boolean = true;
  updatePollution: boolean = true;
  updateInsurance: boolean = true;
  trucksArray: any;
  token: any;
  editTruckFrom!: FormGroup;
  selectTruckValue: any;
  truckList: any = [];
  truck: any = [];
  trucksList: any = [];
  reasons: boolean = true;
  reasonsView: boolean = true;
  remarksArray: any = [];
  RCImage: any;
  permitImage: any;
  fitnessImage: any;
  pollutionImage: any;
  insuranceImage: any;
  RCImageName: any;
  permitImageName: any;
  fitnessImageName: any;
  pollutionImageName: any;
  insuranceImageName: any;
  profileImg: boolean = true;
  loading: boolean = false;
  truck_documents_proofs: any = [];
  truckType: any = "-1";
  truckNumber: any = -1;
  imageRC: any;
  imagePermit: any;
  imageFitness: any;
  imagePollution: any;
  imageInsurance: any;
  truckImageloading: boolean = false;
  rcLoading: boolean = false;
  permitLoading: boolean = false;
  fitnessLoading: boolean = false;
  pollutionLoading: boolean = false;
  insuranceLoading: boolean = false;

  constructor(
    private services: TruckOwnerService,
    private matDialogRef: MatDialogRef<TrucksViewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.token = sessionStorage.getItem("to_token");
    this.trucksGet();
    this.GetCategory();
    this.editTruckFrom = this.formBuilder.group({
      truck_number: [
        "",
        Validators.compose([Validators.pattern("^[A-Z0-9\\s]+$")]),
      ],
      rc_valid: [""],
      home_location: [""],
      make_name: [""],
      truck_model: [""],
      manufacture_year: [""],
      vehicle_rc_expiry: [""],
      vehicle_rc: [""],
      permit_type_expiry: [""],
      permit_type: [""],
      fitness_expiry: [""],
      fitness: [""],
      pollution_expiry: [""],
      pollution: [""],
      insurance_expiry: [""],
      insurance: [""],
      truck_category: ["", [Validators.required]],
      truck_type: ["", [Validators.required]],
      truck_status: [""],
      truck_remarks: [""],
    });

    if (this.data.truck_remarks == "") {
      this.reasonsView = false;
    }
  }

  viewImages() {
    this.imageRC = decodeURI(
      this.data.truck_documents_proofs.vehicle_rc
        .split("/")
        .slice(-1)
        .pop()
        .split("-")
        .slice(-1)
        .pop()
    );
  }

  permitImg() {
    this.imagePermit = decodeURI(
      this.data.truck_documents_proofs.permit_type
        .split("/")
        .slice(-1)
        .pop()
        .split("-")
        .slice(-1)
        .pop()
    );
  }
  fitnessImg() {
    this.imageFitness = decodeURI(
      this.data.truck_documents_proofs.fitness
        .split("/")
        .slice(-1)
        .pop()
        .split("-")
        .slice(-1)
        .pop()
    );
  }
  pollutionImg() {
    this.imagePollution = decodeURI(
      this.data.truck_documents_proofs.pollution
        .split("/")
        .slice(-1)
        .pop()
        .split("-")
        .slice(-1)
        .pop()
    );
  }
  insuranceImg() {
    this.imageInsurance = decodeURI(
      this.data.truck_documents_proofs.insurance
        .split("/")
        .slice(-1)
        .pop()
        .split("-")
        .slice(-1)
        .pop()
    );
  }

  public get truckEditFormControl() {
    return this.editTruckFrom.controls;
  }

  public gettruckCatg(item: any) {
    this.selectTruckValue = item.value;
    this.services.GetTypeTruck(this.selectTruckValue, this.token).subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.truckList = response.body.data;
        }
      },
      (error) => {
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("/");
          sessionStorage.clear();
          this.matDialogRef.close();
        }
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("/");
          sessionStorage.clear();
          this.matDialogRef.close();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }

  public GetCategory() {
    this.services.GetCategory().subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.truck = response.body.data;
        }
      },
      (error) => {
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("/");
          sessionStorage.clear();
          this.matDialogRef.close();
        }
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("/");
          sessionStorage.clear();
          this.matDialogRef.close();
        }
      }
    );
  }

  truckEdit() {
    this.truckProfile = false;
    this.editTruckProfile = true;
    this.truckEditFormControl["truck_number"].setValue(this.data.truck_number);
    this.truckImage = this.data.truck_image;
    this.truckEditFormControl["rc_valid"].setValue(this.data.rc_valid);
    this.truckEditFormControl["home_location"].setValue(
      this.data.home_location
    );
    this.truckEditFormControl["make_name"].setValue(this.data.make_name);
    this.truckEditFormControl["truck_model"].setValue(this.data.truck_model);
    this.truckEditFormControl["manufacture_year"].setValue(
      this.data.manufacture_year
    );
    this.truckEditFormControl["vehicle_rc_expiry"].setValue(
      this.data.truck_documents_proofs.vehicle_rc_expiry
    );
    this.truckEditFormControl["permit_type_expiry"].setValue(
      this.data.truck_documents_proofs.permit_type_expiry
    );
    this.truckEditFormControl["pollution_expiry"].setValue(
      this.data.truck_documents_proofs.pollution_expiry
    );
    this.truckEditFormControl["insurance_expiry"].setValue(
      this.data.truck_documents_proofs.insurance_expiry
    );
    this.truckEditFormControl["fitness_expiry"].setValue(
      this.data.truck_documents_proofs.fitness_expiry
    );
    this.truckEditFormControl["truck_category"].setValue(
      this.data.truckCategoryInfo[0]._id
    );
    this.truckEditFormControl["truck_type"].setValue(
      this.data.truckTypeInfo[0]._id
    );
    this.truckEditFormControl["truck_status"].patchValue(
      this.data.truck_status
    );
    this.truckEditFormControl["truck_remarks"].setValue(
      this.data.truck_remarks
    );
    if (this.data.truck_remarks == "") {
      this.reasons = false;
    }
    this.viewImages();
    this.permitImg();
    this.fitnessImg();
    this.pollutionImg();
    this.insuranceImg();
  }
  trucksGet() {
    this.services
      .getTrucks(this.token, this.truckType, this.truckNumber)
      .subscribe(
        (response: any) => {
          this.trucksArray = response.body.data;
        },
        (error) => {
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("/");
            sessionStorage.clear();
            this.matDialogRef.close();
          }
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("/");
            sessionStorage.clear();
            this.matDialogRef.close();
          }
        }
      );
  }

  public onChange(event: any, type: any): void {
    this.file = event.target.files[0];
    if (type == "Truck") {
      this.truckImageloading = true;
    }
    if (type == "RC") {
      this.rcLoading = true;
    }
    if (type == "PermitType") {
      this.permitLoading = true;
    }
    if (type == "Fitness") {
      this.fitnessLoading = true;
    }
    if (type == "Pollution") {
      this.pollutionLoading = true;
    }
    if (type == "Insurance") {
      this.insuranceLoading = true;
    }
    this.services.uploadImage(this.file).subscribe((response: any) => {
      if (response.status === 201) {
        this.truckImageloading = false;
        this.rcLoading = false;
        this.permitLoading = false;
        this.fitnessLoading = false;
        this.pollutionLoading = false;
        this.insuranceLoading = false;
        if (type == "Truck") {
          this.truckImage = response.body.image_link;
          this.profileImg = false;
        }
        if (type == "RC") {
          this.uploadVehicle = false;
          this.updateRC = false;
          this.RCImageName = this.file.name;
          this.editTruckFrom.value.vehicle_rc = response.body.image_link;
        }
        if (type == "PermitType") {
          this.uploadPermit = false;
          this.updatePermit = false;
          this.permitImageName = this.file.name;
          this.editTruckFrom.value.permit_type = response.body.image_link;
        }
        if (type == "Fitness") {
          this.uploadFitness = false;
          this.updateFitness = false;
          this.fitnessImageName = this.file.name;
          this.editTruckFrom.value.fitness = response.body.image_link;
        }
        if (type == "Pollution") {
          this.uploadPollution = false;
          this.updatePollution = false;
          this.pollutionImageName = this.file.name;
          this.editTruckFrom.value.pollution = response.body.image_link;
        }
        if (type == "Insurance") {
          this.uploadInsurance = false;
          this.updateInsurance = false;
          this.insuranceImageName = this.file.name;
          this.editTruckFrom.value.insurance = response.body.image_link;
        }
      }
    });
  }
  UpdateTruck() {
    if (this.editTruckFrom.value.manufacture_year > new Date().getFullYear()) {
      this.snackBar.open(
        "Manufacture year should be less than current year",
        "Fail",
        {
          duration: 5000,
        }
      );
      return;
    }
    this.editTruckFrom.value["vehicle_rc"] = this.editTruckFrom.value.vehicle_rc
      ? this.editTruckFrom.value.vehicle_rc
      : this.data.truck_documents_proofs.vehicle_rc;
    this.editTruckFrom.value["permit_type"] = this.editTruckFrom.value
      .permit_type
      ? this.editTruckFrom.value.permit_type
      : this.data.truck_documents_proofs.permit_type;
    this.editTruckFrom.value["fitness"] = this.editTruckFrom.value.fitness
      ? this.editTruckFrom.value.fitness
      : this.data.truck_documents_proofs.fitness;
    this.editTruckFrom.value["pollution"] = this.editTruckFrom.value.pollution
      ? this.editTruckFrom.value.pollution
      : this.data.truck_documents_proofs.pollution;
    this.editTruckFrom.value["insurance"] = this.editTruckFrom.value.insurance
      ? this.editTruckFrom.value.insurance
      : this.data.truck_documents_proofs.insurance;
    this.remarksArray.push(this.editTruckFrom.value.truck_remarks);
    const isRcVerified =
      this.data?.rc_verified === true ||
      this.data?.rc_verified === 1 ||
      this.data?.is_rc_verified === true ||
      this.data?.is_rc_verified === 1 ||
      this.data?.truck_documents_proofs?.rc_verified === true ||
      this.data?.truck_documents_proofs?.rc_verified === 1;

    if (this.editTruckFrom.valid) {
      this.truck_documents_proofs = {
        vehicle_rc: this.editTruckFrom.value.vehicle_rc,
        vehicle_rc_expiry: this.editTruckFrom.value.vehicle_rc_expiry,
        permit_type: this.editTruckFrom.value.permit_type,
        permit_type_expiry: this.editTruckFrom.value.permit_type_expiry,
        fitness: this.editTruckFrom.value.fitness,
        fitness_expiry: this.editTruckFrom.value.fitness_expiry,
        pollution: this.editTruckFrom.value.pollution,
        pollution_expiry: this.editTruckFrom.value.pollution_expiry,
        insurance: this.editTruckFrom.value.insurance,
        insurance_expiry: this.editTruckFrom.value.insurance_expiry,
        rc_verified: isRcVerified,
        is_rc_verified: isRcVerified,
      };
      const updateTruckObj = {
        truck_number: this.editTruckFrom.value.truck_number,
        rc_valid: this.editTruckFrom.value.rc_valid,
        home_location: this.editTruckFrom.value.home_location,
        make_name: this.editTruckFrom.value.make_name,
        truck_model: this.editTruckFrom.value.truck_model,
        manufacture_year: this.editTruckFrom.value.manufacture_year,
        truck_image: this.truckImage,
        truck_category: this.editTruckFrom.value.truck_category,
        truck_type: this.editTruckFrom.value.truck_type,
        truck_status: this.editTruckFrom.value.truck_status,
        truck_remarks: this.remarksArray,
        truck_documents_proofs: this.truck_documents_proofs,
        rc_verified: isRcVerified,
        is_rc_verified: isRcVerified,
      };
      this.loading = true;

      this.services
        .truckUpdate(updateTruckObj, this.token, this.data._id)
        .subscribe(
          (response: any) => {
            if (response.status == 200) {
              this.snackBar.open("Truck updated successfully", "Success", {
                duration: 5000,
              });
              this.loading = false;
              this.trucksGet();
              this.matDialogRef.close();
            }
          },
          (error) => {
            this.snackBar.open(error.error.message, "Fail", {
              duration: 5000,
            });
            if (error.error.message === "jwt expired") {
              this.router.navigateByUrl("/");
              sessionStorage.clear();
              this.matDialogRef.close();
            }
            if (error.error.message === "jwt malformed") {
              this.router.navigateByUrl("/");
              sessionStorage.clear();
              this.matDialogRef.close();
            }
          }
        );
    } else {
      this.editTruckFrom.markAllAsTouched();
    }
  }

  close() {
    this.matDialogRef.close();
  }

  maintance() {
    this.editTruckFrom.value.truck_remarks = "";
    this.reasons = false;
  }
  available() {
    this.editTruckFrom.value.truck_remarks = "";
    this.reasons = false;
  }
  rejected() {
    this.reasons = true;
  }

  removeImg(event: any, type: any) {
    if (type == "Truck") {
      this.profileImg = true;
      this.truckImage = "";
    }
    if (type == "RC") {
      this.uploadVehicle = true;
      this.editTruckFrom.value.vehicle_rc = "";
    }
    if (type == "permit") {
      this.uploadPermit = true;
      this.editTruckFrom.value.permit_type = "";
    }
    if (type == "fitness") {
      this.uploadFitness = true;
      this.editTruckFrom.value.firness = "";
    }
    if (type == "pollution") {
      this.uploadPollution = true;
      this.editTruckFrom.value.pollution = "";
    }
    if (type == "insurance") {
      this.uploadInsurance = true;
      this.editTruckFrom.value.insurance = "";
    }
  }
}
